// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-edicao-usuario {
    width: calc(100% - 1.1rem);
    padding-left: 5.1rem;
    padding-top: 3.9rem;
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: center;
    height: max-content;
    gap: 1rem;
}

.container-geral-cadastro-usuario {
    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, .1);
    border-radius: 8px;
    min-width: max-content;
    max-width: 80%;
}

.formulario-edicao-nova-usuario {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: var(--branco-padrao);
    padding: .7rem 1rem;
    border-radius: 0 0 8px 8px;
}

.container-principal-infos-usuario {
    display: flex;
    flex-direction: column;
}

.container-info-principal-usuario {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;
}

.container-nome-email-cadastro-usuarios {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
}

.trocar-foto-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
}

.trocar-foto-container img {
    border-radius: 50%;
    width: 9.3rem;
    height: 9.3rem;
}

.container-cpf-situacao-cadastro {
    display: flex;
    margin-top: 1rem;
    gap: 1rem;
}

.container-tipo-usuario-cadastro-usuario {
    display: flex;
    margin-top: 1rem;
    width: 100%;
    gap: 1rem;
}

.container-senha-cadastro-usuario {
    margin-top: 1.6rem;
    padding-bottom: .3rem;
}

.titulo-senha-cadastro-usuario {
    font-size: 1.1rem;
    font-weight: bold;
    color: var(--azul-dixi);
    margin-bottom: .7rem;
}

.container-senha-confirma-senha {
    margin-top: .8rem;
    display: flex;
    gap: 1rem;
}

.container-botoes-cadastro-usuario {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-top: .5rem;
}

/* Lateral para vinculo de departamento */
.container-adicional-cadastro-usuario {
    min-width: -moz-fit-content;
    min-width: fit-content;
    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, .1);
    display: flex;
    flex-direction: column;
    border-radius: 8px;
}

.container-departamentos-vinculados {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: .7rem 1rem;
}

.container-departamentos-vinculados button {
    margin: auto;
}

.departamentos-vinculados-list {
    display: flex;
    flex-direction: column;
    list-style: none;
    gap: .4rem;
}

.departamentos-vinculados-list li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding: .5rem 1rem;
    border-radius: 8px;
    font-weight: 500;
    color: var(--text-color);
    background-color: var(--cinza-fundo-input-padrao2);
    position: relative;
}

.departamentos-vinculados-list li svg {
    position: absolute;
    font-size: 1.2rem;
    top: 8px;
    right: 10px;
    color: var(--vermelho-padrao);
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/FormEditarUsuario/FormEditarUsuario.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sCAAsC;IACtC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;AACrB;;AAEA,yCAAyC;AACzC;IACI,2BAAsB;IAAtB,sBAAsB;IACtB,6CAA6C;IAC7C,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;IACR,WAAW;IACX,6BAA6B;IAC7B,eAAe;AACnB","sourcesContent":[".container-edicao-usuario {\n    width: calc(100% - 1.1rem);\n    padding-left: 5.1rem;\n    padding-top: 3.9rem;\n    display: flex;\n    flex-direction: row;\n    align-items: start;\n    justify-content: center;\n    height: max-content;\n    gap: 1rem;\n}\n\n.container-geral-cadastro-usuario {\n    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, .1);\n    border-radius: 8px;\n    min-width: max-content;\n    max-width: 80%;\n}\n\n.formulario-edicao-nova-usuario {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    background-color: var(--branco-padrao);\n    padding: .7rem 1rem;\n    border-radius: 0 0 8px 8px;\n}\n\n.container-principal-infos-usuario {\n    display: flex;\n    flex-direction: column;\n}\n\n.container-info-principal-usuario {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    width: 100%;\n}\n\n.container-nome-email-cadastro-usuarios {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    width: 100%;\n}\n\n.trocar-foto-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    align-items: center;\n    justify-content: center;\n    margin-top: 1rem;\n}\n\n.trocar-foto-container img {\n    border-radius: 50%;\n    width: 9.3rem;\n    height: 9.3rem;\n}\n\n.container-cpf-situacao-cadastro {\n    display: flex;\n    margin-top: 1rem;\n    gap: 1rem;\n}\n\n.container-tipo-usuario-cadastro-usuario {\n    display: flex;\n    margin-top: 1rem;\n    width: 100%;\n    gap: 1rem;\n}\n\n.container-senha-cadastro-usuario {\n    margin-top: 1.6rem;\n    padding-bottom: .3rem;\n}\n\n.titulo-senha-cadastro-usuario {\n    font-size: 1.1rem;\n    font-weight: bold;\n    color: var(--azul-dixi);\n    margin-bottom: .7rem;\n}\n\n.container-senha-confirma-senha {\n    margin-top: .8rem;\n    display: flex;\n    gap: 1rem;\n}\n\n.container-botoes-cadastro-usuario {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n    margin-top: .5rem;\n}\n\n/* Lateral para vinculo de departamento */\n.container-adicional-cadastro-usuario {\n    min-width: fit-content;\n    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, .1);\n    display: flex;\n    flex-direction: column;\n    border-radius: 8px;\n}\n\n.container-departamentos-vinculados {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding: .7rem 1rem;\n}\n\n.container-departamentos-vinculados button {\n    margin: auto;\n}\n\n.departamentos-vinculados-list {\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n    gap: .4rem;\n}\n\n.departamentos-vinculados-list li {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    height: 100%;\n    padding: .5rem 1rem;\n    border-radius: 8px;\n    font-weight: 500;\n    color: var(--text-color);\n    background-color: var(--cinza-fundo-input-padrao2);\n    position: relative;\n}\n\n.departamentos-vinculados-list li svg {\n    position: absolute;\n    font-size: 1.2rem;\n    top: 8px;\n    right: 10px;\n    color: var(--vermelho-padrao);\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
